export default {
    organization: 'Working Group',
    project: 'Project',
    dataset: 'Dataset',
    report: 'Report',
    visualization: 'Visualization',
    download: 'Download zip',
    events: 'Events',
    processing: 'Processing...',

    date: 'Date',
    createdAt: 'Created at',
    updateDate: 'Last update',
    projectCount: 'Projects contained',
    datasetCount: 'Datasets contained',
    deleteDate: 'Delete on',
    startAt: 'Start at',
    endAt: 'End at',
    seenAt: 'Seen at',
    content: 'Content',

    code: 'Code',
    title: 'Title',
    name: 'Name',
    description: 'Description',
    status: 'Status',
    model: 'Model',
    email: 'Email',
    amount: 'Amount',
    actions: 'Actions',
    type: 'Type',
    file: 'File',
    characters: 'characters',

    owner: 'Owner',
    sortBy: 'Sort by',
    sortDirection: 'Direction',
    ascending: 'Ascending',
    descending: 'Descending',

    readOnly: 'Read-only',
    archived: 'Archived',
    optional: 'Optional',
    uploadData: 'Upload Data',
    comingSoon: 'Coming soon',

    account: 'Account',
    profile: 'Profile',
    apis: 'API Token',
    signout: 'Sign out',

    back: 'Back',
    forward: 'Forward',

    zoomIn: 'Zoom in',
    zoomOut: 'Zoom out',

    info: 'Information',
    updateData: 'Update data',
    replaceData: 'Replace data',
    dataOptions: 'Data options',

    filters: 'Filters',
    sorting: 'Sorting',
}
